/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { all, call, CallEffect } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { Asset, FileFormat, Folder, Ducks, CollectionApi } from '@wit/vtv-x-foundation-lib';
import { SagaFunctions as FoldersSagaFunctions } from '../folders';

function* getCollectionIdsForMediaFiles(assets: Asset[]): SagaIterator<string[]> {
  const tasks: CallEffect[] = [];

  assets.forEach((asset) => {
    asset.streams
      .filter((stream) => stream.fileFormat !== FileFormat.TRAILER)
      .forEach((stream) => {
        tasks.push(Ducks.Api.callApi(CollectionApi.getCollectionsIds, stream.id));
      });
  });

  const collectiondsByFile: string[][] = yield all(tasks);

  return collectiondsByFile.reduce((results, fileCollectionIds) => [...results, ...fileCollectionIds], []);
}

function* getRelatedCollectionIds(clones: Asset[]): SagaIterator<string[]> {
  const ids: string[] = yield call(getCollectionIdsForMediaFiles, clones);

  return [...new Set(ids)]; // return only distinct values
}

function* getRelatedCollectionFolders(clones: Asset[]): SagaIterator<Folder[]> {
  // clones are: AssetMediaType.EPISODE, AssetMediaType.MOVIE, AssetMediaType.RECORDING and AssetMediaType.EPG
  const uniqueColectionIds = yield call(getRelatedCollectionIds, clones);
  return yield call(FoldersSagaFunctions.getCollectionsFolders, uniqueColectionIds);
}

export default {
  getRelatedCollectionFolders,
};
